/**
 * Converts a time sting like "11:50" to a number like 1150 to allow comparing two time strings.
 *
 * @param timeStr
 * @returns {number}
 */
export function timeStrToNum(timeStr) {
  if (timeStr === null) return 0;
  const [hours, minutes] = timeStr.split(':').map(x => parseInt(x, 10));
  return hours * 100 + minutes;
}

/**
 * Increments the hours and / or minutes in a time string while ensuring that time is within valid
 * range.
 *
 * @param timeStr
 * @param hours
 * @param minutes
 * @returns {string}
 */
// export function timeStrIncrement(timeStr, {hours, minutes}) {
//   const [hrs, mins] = timeStr.split(':').map(x => parseInt(x, 10));
//   const incHours = Math.min(hrs + (hours || 0), 23);
//   const incMinutes = Math.min(mins + (minutes || 0), 59);
//   return `${incHours}:${incMinutes}`;
// }

export function timeStrIncrement(timeStr, {hours, minutes}) {
  const [hrs, mins] = timeStr.split(':').map(x => parseInt(x, 10));
  const incHours = Math.min(hrs + (hours || 0), 23);
  const incMinutes = Math.min(mins + (minutes || 0), 59);

  // Pad the hours and minutes with leading zeros if necessary
  const formattedHours = incHours.toString().padStart(2, '0');
  const formattedMinutes = incMinutes.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:00`; // Ensure seconds are added
}

export const Time = {
  hours: Array.apply(null, Array(24)).map((_, i) => i.toString().padStart(2, '0')),
  minutes: ['00', '15', '30', '45'],
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/time.js